import { ResolveFn } from '@angular/router';
import { LOCATION_DATA } from './location-loaders';
import { PortLocation } from './location-types';

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The route's canMatch has already checked the location exists.
// location-copy is imported on demand so the location index stays out of the main bundle.
export const locationResolver: ResolveFn<PortLocation | undefined> = async route => {
  const { findLocation } = await import('./location-copy');
  const entry = findLocation(route.paramMap.get('location'));
  if (!entry) return undefined;
  const list = await LOCATION_DATA[entry.state]();
  return list.find(l => l.code === entry.code);
};
